export const Header = () => {
  return (
    <header className="header">
      
    </header>
  );
}